export const handleFundingSubCategory_Helper = (
  funding_sub_category,
  selectedOption,
  funding_category
) => {
  let selected_ac = new Set();
  selectedOption.map((s) => {
    let find_ac = funding_sub_category.find((sc) => {
      return (
        sc.proposed_sub_category === s.value &&
        funding_category === sc.proposed_funding_category
      );
    });
    if (find_ac) {
      let splitted = find_ac.activity_codes.split(",");
      splitted.map((item) => {
        selected_ac.add(item);
      });
    }
  });
  const f_ac = [...selected_ac];
  if (f_ac && f_ac.length > 0) {
    let updateDataQuery = {
      activitycodes: f_ac.join(","),
    };
    return updateDataQuery;
  }
};
